import { ServiceResponse } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { ViewChild } from '@angular/core';
import { NgModel, NgForm } from '@angular/forms';
import { Transport } from './../model/transport';

import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransportIssue } from '../model/transport-issue';
import { ResponseMessage } from '@sdbn/common';
import { AppClientConfigurationService } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';

@Component({
    selector: 'app-transport-issues-dialog',
    templateUrl: './transport-issues-dialog.component.html',
    styleUrls: ['./transport-issues-dialog.component.scss'],
    standalone: false
})
export class TransportIssuesDialogComponent implements OnInit {

  isLoading = false;

  @ViewChild('editForm', { static: true }) editForm: NgForm;

  responseMessages: ResponseMessage[] = [];

  newIssueId = 0;

  constructor(
    public dialogRef: MatDialogRef<TransportIssuesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public transport: Transport,
    public translationService: TranslationService,
    private appServerAPI: AppServerAPI,
    public cps: AppClientConfigurationService
  ) { }

  ngOnInit() { }

  public cancel() {
    this.dialogRef.close();
  }

  public isSaveDisabled() {
    return this.isLoading || this.editForm.invalid;
  }

  public isAddIssueDisabled() {
    return this.isLoading;
  }

  public save() {

    this.isLoading = true;
    this.responseMessages = [];

    this.appServerAPI.execute<ServiceResponse>('/client/control/transport/issues/save', this.transport).subscribe(
      response => {
        if (ServiceResponse.isFailed(response)) {
          this.responseMessages = this.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.isLoading = false;
      }, error => {
        console.log('error while savin transport issues' + error);
        this.isLoading = false;
      }
    );
  }

  public addIssue() {

    const newIssue = new TransportIssue();
    newIssue.id = --this.newIssueId;
    if (this.transport.issueTypes != null && this.transport.issueTypes.length > 0) {
      newIssue.issueTypeId = this.transport.issueTypes[0].id;
      newIssue.delay = this.transport.issueTypes[0].delay;
    }

    this.transport.transportIssues.push(newIssue);
  }

  public isRemoveIssueDisabled(issue: TransportIssue) {
    return this.isLoading;
  }

  public removeIssue(issue: TransportIssue) {
    if (issue.id > 0) {
      issue.deleted = true;
    } else {
      const index = this.transport.transportIssues.indexOf(issue);
      this.transport.transportIssues.splice(index, 1);
    }
  }

  public showValuePositiveIntegerError(ctrl: NgModel) {
    return ctrl.touched && ctrl.hasError('positiveInteger');
  }

  public getNonDeletedIssues() {
    return this.transport.transportIssues.filter(i => !i.deleted);
  }

  /**
   * Prevents events on keydown.enter in the form.
   * Must return false!
   */
  public preventEnterKeydown(): boolean {
    return false;
  }

  public onTypeSelectionChange(event: any, issue: TransportIssue) {
    if (this.transport.issueTypes != null) {
      const type = this.transport.issueTypes.find(i => i.id === event.value);
      issue.delay = type.delay;
    }
  }
}
